module.exports = __webpack_public_path__ + "img/ZB52_13.a226f62a.jpg";